import type { ReactNode } from 'react';

/**
 * One figure on the overview.
 *
 * `value` being null means the desk has nothing behind it yet, and the card
 * says so instead of showing a zero dressed up as a measurement. Zero paying
 * members and no plans priced are different facts, and a dashboard that shows
 * "₹0" for both teaches its reader to distrust it.
 */
export function Stat({ label, value, note, hint, className }: {
  label: string;
  value: string | null;
  note?: ReactNode;
  hint?: string;
  className?: string;
}) {
  return (
    <div className={`crd stat-card ${className || ''}`} style={{ padding: '22px 24px' }}>
      <div className="kh stat-label" style={{ marginBottom: 10 }}>{label}</div>
      {value === null ? (
        <>
          <div className="stat-val" style={{ fontFamily: 'var(--fd)', fontSize: 30, fontWeight: 600, color: 'var(--tx3)' }}>—</div>
          {hint ? <div className="stat-note" style={{ fontSize: 11.5, color: 'var(--tx3)', marginTop: 8 }}>{hint}</div> : null}
        </>
      ) : (
        <>
          <div className="stat-val" style={{ fontFamily: 'var(--fd)', fontSize: 34, fontWeight: 600, lineHeight: 1.05 }}>{value}</div>
          {note ? <div className="stat-note" style={{ fontSize: 11.5, color: 'var(--tx3)', marginTop: 8 }}>{note}</div> : null}
        </>
      )}
    </div>
  );
}
